import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import VueD3 from "vue-d3";
import SuiVue from "semantic-ui-vue";
import store from "./store";
import router from "./router";
import Driver from "driver.js";
import { round } from "./utils/filters";
import "semantic-ui-css/semantic.min.css";
import "driver.js/dist/driver.min.css";
import config from "@/utils/config";
import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";

Vue.config.productionTip = false;
Vue.use(SuiVue);
Vue.use(VueD3);
Vue.filter("round", round);

const driver = new Driver({
  opacity: 0.75,
  allowClose: false
});
Vue.prototype.$driver = driver;
Vue.prototype.$config = config;

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount("#app");

Sentry.init({
  Vue,
  dsn:
    "https://24c967ecf5684fb59b34473c4d254c64@o341782.ingest.sentry.io/5669395",
  autoSessionTracking: true,
  integrations: [
    new BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracePropagationTargets: ["localhost", "aml-risk-model.com", /^\//]
    }),
    new Sentry.Replay()
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0
});
